module.exports = __webpack_public_path__ + "images/home/index/values-timeline-bg-71588be46f2241a2d9664dd4af925d34.png";